import { render, staticRenderFns } from "./Navigation-Drawer-Item.vue?vue&type=template&id=29d4eb6f&lang=pug"
import script from "./Navigation-Drawer-Item.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navigation-Drawer-Item.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Navigation-Drawer-Item.vue?vue&type=style&index=0&id=29d4eb6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports